import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  CommentServiceClient,
  CommentApiClient,
} from '../../common/services/httpClient';

const mapThread = (t) => ({
  ...t,
  id: t.id.toLowerCase(),
  comments: t.comments.map((c) => ({
    ...c,
    commentId: c.commentId.toLowerCase(),
    threadId: t.id.toLowerCase(),
  })),
});

export const getCommentsByEntity = async (
  projectId,
  entityType,
  entityId,
  entityVersion,
  isEntitySharedWithClient
) => {
  const response = await CommentServiceClient(projectId).get(
    `${projectId}/${entityType}/${entityId}/threads?entityVersion=${entityVersion}&isEntitySharedWithClient=${isEntitySharedWithClient}`
  );

  return response.data.map(mapThread);
};

export const addCommentToEntity = createAsyncThunk(
  'comments/addCommentToEntity',
  async (comment) => {
    const response = await CommentServiceClient(
      comment.projectId
    ).postDeprecated(
      `${comment.projectId}/${comment.entityType}/${comment.entityId}/threads`,
      comment
    );

    return response.data;
  }
);

export const updateComment = async (comment) => {
  await CommentServiceClient(comment.projectId).patch(
    `${comment.projectId}/${comment.entityType}/${comment.entityId}/comments/${comment.commentId}/content`,
    comment
  );
};

export const deleteCommentThread = createAsyncThunk(
  'comments/deleteCommentThread',
  async (thread) => {
    await CommentServiceClient(thread.projectId).delete(
      `${thread.projectId}/${thread.entityType}/${thread.entityId}/threads/${
        thread.id || thread.threadId
      }`
    );
  }
);

export const deleteComment = async (comment) => {
  await CommentServiceClient(comment.projectId).delete(
    `${comment.projectId}/${comment.entityType}/${comment.entityId}/threads/${comment.threadId}/comments/${comment.commentId}`
  );
};

export const resolveCommentThread = async (comment) => {
  await CommentServiceClient(comment.projectId).patch(
    `${comment.projectId}/${comment.entityType}/${comment.entityId}/threads/${comment.threadId}/resolve`,
    comment
  );
};

export const getCommentCounts = createAsyncThunk(
  'comments/getCommentCounts',
  async ({ projectId, entityType, entityId, draftVersion, sharedVersion }) => {
    const response = await CommentServiceClient(projectId).get(
      `${projectId}/${entityType}/${entityId}/count?draftVersion=${draftVersion}&sharedVersion=${sharedVersion}`
    );

    return response.data;
  }
);

export const getCommentCountsByContentId = createAsyncThunk(
  'comments/getCommentCountsByContentId',
  async ({ projectId, contentId, isShared }) => {
    const searchParams = String(
      new URLSearchParams({
        ...(typeof isShared !== 'undefined' && { isShared }),
      })
    );
    const renderSearchParams =
      searchParams.length > 0 ? `?${searchParams}` : '';

    const response = await CommentApiClient(projectId).get(
      `${projectId}/Threads/counts/${contentId}${renderSearchParams}`
    );

    return response.data;
  }
);

export const resolveAllComments = async (
  projectId,
  entityType,
  entityId,
  threadIds
) => {
  await CommentServiceClient(projectId).postDeprecated(
    `${projectId}/${entityType}/${entityId}/threads/resolve`,
    {
      threadIds,
    }
  );
};
